let btnMobile = document.querySelector('#btn-mobile');

function toggleMenu() {
    let nav = document.querySelector('#nav');
    nav.classList.toggle('active');
}

if(btnMobile) {
    btnMobile.addEventListener('click', toggleMenu);
}
